import { CamerasAction, CamerasState } from "./types";
import { initialState } from "./initialState";
import {
  CAMERAS_RESET_STREAMS,
  CAMERAS_SET_CAMERAS_STREAM_ERROR,
  CAMERAS_SET_CAMERAS_STREAM_FETCH,
  CAMERAS_SET_CAMERAS_STREAM_STATUS,
  CAMERAS_SET_CAMERAS_STREAM_SUCCESS,
  CAMERAS_SET_CAPIBILITIES,
  CAMERAS_SET_CURRENT_CAMERA,
  CAMERAS_SET_CURRENT_CAMERAS,
  CAMERAS_SET_CURRENT_STREAMS,
  CAMERAS_SET_INIT_ALL_STREAM_STATUS,
  CAMERAS_SET_INIT_ONE_STREAM_STATUS,
  CAMERAS_SET_PRESETS,
  CAMERAS_SET_PTZ_MODE,
  CAMERAS_SET_CAMERA_LIST_SEARCH_QUERY,
  CAMERAS_SET_DEVICE_STATUS,
  CAMERAS_SET_CAMERA_RELOAD,
  CAMERAS_CLEAR_PANE
} from "../../constants/cameras";
import { API_AUTH_RESET } from "../../constants/API";


const reducer = (state: CamerasState = initialState, action: CamerasAction) => {
  switch (action.type) {
    case CAMERAS_SET_CURRENT_CAMERAS:
      return {
        ...state,
        currentCameras: action.cameras,
      };

    case CAMERAS_SET_CURRENT_STREAMS: {
      return {
        ...state,
        currentStreams: {
          ...state.currentStreams,
          [action.pane]: action.stream
        }
      };
    }

    case CAMERAS_CLEAR_PANE: {
      delete state.currentCameras[action.pane];
      delete state.currentStreams[action.pane];
      delete state.streamStatuses[action.pane];
      return {
        ...state,
        currentCameras: {
          ...state.currentCameras,
          [action.pane]: null
        }
      };
    }

    case CAMERAS_SET_INIT_ALL_STREAM_STATUS:
      return {
        ...state,
        streamStatuses: action.streams,
      };

    case CAMERAS_SET_INIT_ONE_STREAM_STATUS:
      return {
        ...state,
        streamStatuses: {
          ...state.streamStatuses,
          [action.pane]: {status: 'created', data: ''}
        }
      };

    case('setOpenedCameraList'):
      return {
        ...state,
        openedCameraList: action.opened
      };

    case('shutAlllists'):
      return {
        ...state,
        openedCameraList: false
      };

    case CAMERAS_SET_CURRENT_CAMERA: {
      delete state.ptzModes[action.pane];
      delete state.ptzCapibilities[action.pane];
      delete state.presets[action.pane];

      return {
        ...state,
        openedCameraList: false,
        currentCameras: {
          ...state.currentCameras,
          [action.pane]: {
            ...action.camera,
            reload: 0
          }
        }
      };
    }

    case CAMERAS_SET_CAMERAS_STREAM_FETCH: {
      return {
        ...state,
        streamStatuses: {
          ...state.streamStatuses,
          [action.pane]: {
            status: 'fetch',
            requestId: action.requestId,
            data: null
          }
        }
      }
    }

    case CAMERAS_SET_CAMERAS_STREAM_SUCCESS: {
      return {
        ...state,
        streamStatuses: {
          ...state.streamStatuses,
          [action.pane]: {
            status: 'success',
            requestId: '',
            data: action.payload
          }
        }
      }
    }

    case CAMERAS_SET_CAMERAS_STREAM_ERROR : {
      return {
        ...state,
        streamStatuses: {
          ...state.streamStatuses,
          [action.pane]: {
            status: 'error',
            requestId: '',
            data: action.payload
          }
        }
      }
    }

    case CAMERAS_SET_CAMERAS_STREAM_STATUS: {
      return {
        ...state,
        streamStatuses: {
          ...state.streamStatuses,
          [action.pane]: {
            status: action.streamStatus.status,
            data: action.streamStatus.data
          }
        }
      }
    }

    case CAMERAS_SET_CAMERA_LIST_SEARCH_QUERY:
      return {
        ...state,
        cameraListSearchQuery: action.query
      };


    // others actions

    case 'triggerLayoutList' :
      return {
        ...state,
        openedCameraList: false
      };

    case('setCurrentLayout'):
      return {
        ...state,
        currentCameras: [],
        currentStreams: {},
        streamStatuses: {},
        ptzModes: {},
        ptzCapibilities: {},
        presets: {}
      };

    case('setCheckedPane'):
      return {
        ...state,
        openedCameraList: false
      };

    case CAMERAS_RESET_STREAMS:
      return {
        ...state,
        streamStatuses: {}
      };

    case CAMERAS_SET_PTZ_MODE :
      return {
        ...state,
        ptzModes: {
          ...state.ptzModes,
          [action.pane]: action.ptzMode
        }
      };

    case CAMERAS_SET_CAPIBILITIES:
      return {
        ...state,
        ptzCapibilities: {
          ...state.ptzCapibilities,
          [action.pane]: action.data
        }
      };

    case CAMERAS_SET_PRESETS:
      return {
        ...state,
        presets: {
          ...state.presets,
          [action.pane]: action.presets
        }
      };

    case CAMERAS_SET_DEVICE_STATUS:
      return {
        ...state,
        currentCameras: {
          ...state.currentCameras,
          [action.pane]: {
            ...state.currentCameras[action.pane],
            state: action.status
          }
        }
      };

    case CAMERAS_SET_CAMERA_RELOAD: {
      const reloadCount = (state.currentCameras[action.pane] && state.currentCameras[action.pane].reload) ? state.currentCameras[action.pane].reload : 0;
      return {
        ...state,
        currentCameras: {
          ...state.currentCameras,
          [action.pane]: {
            ...state.currentCameras[action.pane],
            reload: reloadCount + 1
          }
        }
      };
    }

    case API_AUTH_RESET :
      return {
        ...initialState
      };

    case 'setMapInfo' :
      return {
        ...state,
        currentCameras: {
          ...Object.values(state.currentCameras).map((el: any) => {
            if (el?.id === action.data["a:MapID"]) {
              return {
                ...el,
                bgImg: action.data["a:BackgroundImage"],
                subentities: {
                  ['a:GeneralEntityInfo']: action.data["a:MapElements"]
                }
              }
            }
            return el;
          })
        }
      }

    case 'setWebPageInfo' :
      return {
        ...state,
        currentCameras: {
          ...Object.values(state.currentCameras).map((el: any) => {
            if (el?.id === action.data["a:EntityID"]) {
              return {
                ...el,
                url: action.data["a:URL"]
              }
            }
            return el;
          })
        }
      }

    default:
      return {...state}
  }
};

export default reducer